import type { CSSProperties } from "react";
import { Box, Text } from "@mantine/core";
import { continuationHeaderStyle } from "./DocumentHeaderStyles";

interface DocumentFooterProps {
  patientName: string;
  caseNumber: string;
  pageNumber: number;
  totalPages: number;
}

const footerRowStyle: CSSProperties = {
  display: "grid",
  gridTemplateColumns: "minmax(0, 1fr) auto minmax(0, 1fr)",
  alignItems: "baseline",
  columnGap: 8,
  paddingLeft: "5.75pt",
  paddingRight: "5.75pt",
};

const footerEdgeTextStyle: CSSProperties = {
  ...continuationHeaderStyle,
  minWidth: 0,
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
};

const footerPageTextStyle: CSSProperties = {
  ...continuationHeaderStyle,
  textAlign: "center",
  whiteSpace: "nowrap",
};

const footerCaseTextStyle: CSSProperties = {
  ...footerEdgeTextStyle,
  textAlign: "right",
};

export function DocumentFooter({
  patientName,
  caseNumber,
  pageNumber,
  totalPages,
}: DocumentFooterProps) {
  return (
    <Box mt={12} style={footerRowStyle} data-report-page-footer="true">
      <Text style={footerEdgeTextStyle}>Patient Name: {patientName}</Text>
      <Text style={footerPageTextStyle}>
        Page {pageNumber} of {totalPages}
      </Text>
      <Text style={footerCaseTextStyle}>Case Number: {caseNumber}</Text>
    </Box>
  );
}
